export default __webpack_public_path__ + "static/media/023-beach ball.bf7993b5.svg";